import CircularProgress from '@material-ui/core/CircularProgress';
import { useEffect } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { Subscribe } from 'unstated';

import UserContainer from '~/containers/User';
import { isAuthRoute } from '~/lib/client';

interface GatekeeperProps extends RouteComponentProps {
  currentAccountLoaded: boolean;
  currentUserLoaded: boolean;
  noAccess: boolean;
}
function Gatekeeper({
  currentUserLoaded,
  currentAccountLoaded,
  history,
  noAccess,
}: GatekeeperProps) {
  useEffect(() => {
    if (!currentAccountLoaded) {
      return;
    }

    if (
      window.location.pathname.startsWith('/settings/configuration') ||
      window.location.pathname.startsWith('/get-started')
    ) {
      return;
    }

    if (noAccess) {
      if (history.location.pathname !== '/no-access') {
        history.push('/no-access');
        return;
      }
    } else if (history.location.pathname === '/no-access') {
      history.push('/');
      return;
    }
  }, [currentAccountLoaded, noAccess]);

  if (isAuthRoute()) {
    return null;
  }

  if (currentUserLoaded && currentAccountLoaded) {
    return null;
  }

  return (
    <div className="absolute top-0 bottom-0 left-0 right-0 flex flex-col items-center justify-center text-white bg-gray-800 z-[1000] text-md">
      <CircularProgress />
    </div>
  );
}

const SubscribedGatekeeper = (props: RouteComponentProps) => (
  <Subscribe to={[UserContainer]}>
    {(container: typeof UserContainer) => (
      <Gatekeeper
        currentAccountLoaded={container.currentAccountLoaded()}
        currentUserLoaded={container.currentUserLoaded()}
        noAccess={container.hasNoAccess()}
        {...props}
      />
    )}
  </Subscribe>
);

// withRouter is important here because this component lives outside our normal switch statement.
// For example an update wont happen if a user clicks the browser back button
export default withRouter(SubscribedGatekeeper);
